import React from "react";
import { ArrowLeftOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useUsers } from "../../users/hooks/useUsers";
import { CaUserAcademy } from "../../../types/dto/program";
import {
  WrapperAcademyProgramsStudent,
  WrapperModalPayment,
  WrapperModalQualificationStudent,
  WrapperModalEditProgramStudent,
} from "./styled";
import UpdateStudent from "./programStudent/UpdateStudent";
import { WrapperCardUserOrder } from "../../orders/ui/styled";
import { WrapperTabNav } from "../../products";
import { TableListProgramQualification } from "./qualifications/TableListProgramQualification";
import { Button, Typography } from "antd";
import { TableProgramPersonalInfo } from "./programStudent/TableProgramPersonalInfo";
import PayStudentProgramFromStudentView from "./programStudent/PayStudentProgramFromStudentView";
import CreateStudentQualification from "./qualifications/CreateStudentQualification";
import { StudentPaymentStatusTab } from "./programStudent/StudentPaymentStatusTab";
import { TablePersonalInfoStudentPayment } from "./programStudent/TablePersonalInfoStudentPayment";
import { TablePaymentScheduleStudent } from "./qualifications/TablePaymentScheduleStudent";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux";
import { isRestrictedTeacher } from "../../../shared/utils/roles";

const { Title } = Typography;

export const AcademyProgramPersonalInfo = () => {
  const [studentInfo, setStudentInfo] = React.useState<CaUserAcademy>();
  const [openModalPaymentProgram, setOpenModalPaymentProgram] =
    React.useState<boolean>(false);
  const [paymentHistoryRefreshKey, setPaymentHistoryRefreshKey] =
    React.useState(0);

  const bumpPaymentData = React.useCallback(() => {
    setPaymentHistoryRefreshKey((current) => current + 1);
  }, []);
  const [openModalQualificationStudent, setOpenModalQualificationStudent] =
    React.useState<boolean>(false);
  const [openModalEditStudent, setOpenModalEditStudent] =
    React.useState<boolean>(false);
  const qualificationsRefreshRef = React.useRef<(() => void) | null>(null);

  const { findUserById } = useUsers();
  const { user_id, program_id } = useParams();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const user = useSelector(selectUser);

  const activeTab = searchParams.get("tab") ?? "3";

  const handleTabChange = (key: string) => {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.set("tab", key);
        next.delete("skip");
        next.delete("currentPage");
        next.delete("page");
        return next;
      },
      { replace: true }
    );
  };

  React.useEffect(() => {
    const fetch = async () => {
      await findUserById(+user_id!).then((it) => setStudentInfo(it));
    };
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user_id]);

  const goBack = () => {
    navigate(`/gestion-academy/programs/details/${program_id}`);
  };

  return (
    <WrapperAcademyProgramsStudent>
      <div>
        <span
          className="flex items-center underline text-gray-500 cursor-pointer"
          onClick={goBack}
        >
          <ArrowLeftOutlined className="mr-2" />
          Ir atrás
        </span>
        <div className="flex items-center justify-between gap-4">
          <Title style={{ textAlign: "left", fontSize: 30, margin: 0 }}>
            Información del estudiante
          </Title>
          <Button
            type="primary"
            shape="round"
            icon={<EditOutlined />}
            size="large"
            onClick={() => setOpenModalEditStudent(true)}
          >
            Editar datos
          </Button>
        </div>
        <WrapperCardUserOrder>
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              width: "100%",
              flexWrap: "wrap",
            }}
          >
            <div>
              <label className="text-gray-500">Nombre:</label>
              <p>{studentInfo?.first_name}</p>
            </div>
            <div>
              <label className="text-gray-500">Apellido:</label>
              <p>{studentInfo?.last_name}</p>
            </div>
            <div>
              <label className="text-gray-500">Email:</label>
              <p>{studentInfo?.email}</p>
            </div>
            <div>
              <label className="text-gray-500">Teléfono:</label>
              <p>{studentInfo?.phone}</p>
            </div>
          </div>
        </WrapperCardUserOrder>
      </div>
      <div>
        <Title style={{ textAlign: "left", fontSize: 30, marginTop: 10 }}>
          Programa
        </Title>
        <WrapperTabNav
          activeKey={activeTab}
          onChange={handleTabChange}
          items={[
            {
              label: `PROGRAMAS DEL ESTUDIANTE`,
              key: "3",
              children: <TableProgramPersonalInfo studentId={+user_id!} />,
            },
            {
              label: `HISTORIAL DE CALIFICACIONES`,
              key: "5",
              children: (
                <div>
                  <div className="text-right">
                    <Button
                      type="primary"
                      shape="round"
                      icon={<PlusOutlined />}
                      size="large"
                      onClick={() => setOpenModalQualificationStudent(true)}
                    >
                      Calificar Estudiante
                    </Button>
                  </div>
                  <TableListProgramQualification
                    onTableReady={(refresh) => {
                      qualificationsRefreshRef.current = refresh;
                    }}
                  />
                </div>
              ),
            },
            {
              label: "HISTORIAL DE PAGOS REALIZADOS",
              key: "4",
              children: (
                <StudentPaymentStatusTab
                  readOnly={isRestrictedTeacher(user?.role)}
                  onPayClick={() => setOpenModalPaymentProgram(true)}
                  refreshKey={paymentHistoryRefreshKey}
                />
              ),
            },
            ...(!isRestrictedTeacher(user?.role)
              ? [
                  {
                    label: "ESTADO DE PAGOS",
                    key: "6",
                    children: (
                      <div>
                        <div className="text-right mb-4">
                          <Button
                            type="primary"
                            shape="round"
                            icon={<PlusOutlined />}
                            size="large"
                            onClick={() => setOpenModalPaymentProgram(true)}
                          >
                            Pagar programa
                          </Button>
                        </div>
                        <TablePersonalInfoStudentPayment
                          refreshKey={paymentHistoryRefreshKey}
                          onPaymentChange={bumpPaymentData}
                        />
                      </div>
                    ),
                  },
                  {
                    label: "GESTIONAR CRONOGRAMA DE CUOTAS",
                    key: "7",
                    children: <TablePaymentScheduleStudent />,
                  },
                ]
              : []),
          ]}
        />
      </div>
      <WrapperModalPayment
        title={`Asignar pago al estudiante `}
        open={openModalPaymentProgram}
        width={"320px"}
        destroyOnClose
        onClose={() => setOpenModalPaymentProgram(false)}
      >
        <PayStudentProgramFromStudentView
          setOpenModal={setOpenModalPaymentProgram}
          onSuccess={bumpPaymentData}
        />
      </WrapperModalPayment>
      <WrapperModalEditProgramStudent
        title="Editar datos del estudiante"
        open={openModalEditStudent}
        width="360px"
        destroyOnClose
        onClose={() => setOpenModalEditStudent(false)}
      >
        <UpdateStudent
          studentId={+user_id!}
          onSuccess={(updated) => {
            setStudentInfo(updated);
            setOpenModalEditStudent(false);
          }}
        />
      </WrapperModalEditProgramStudent>
      <WrapperModalQualificationStudent
        title={`Calificar al estudiante`}
        open={openModalQualificationStudent}
        width={"320px"}
        destroyOnClose
        onClose={() => setOpenModalQualificationStudent(false)}
      >
        <CreateStudentQualification
          setOpenModal={setOpenModalQualificationStudent}
          onSuccess={() => qualificationsRefreshRef.current?.()}
        />
      </WrapperModalQualificationStudent>
    </WrapperAcademyProgramsStudent>
  );
};
